import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const ValorizationGpc = lazy(() => lazyRetry(() => import('../containers/ValorizationGpc')))

const baseUrl = '/valorizacao-gpc'

const route = [
  {
    name: i18n.t('routes.valorizationGpc.index'),
    path: baseUrl,
    main: ValorizationGpc,
    exact: true,
    permissions: ['ROLE_ACESSO_VALORIZACAO_GPC_REFERENCIA']
  }
]

export default route
